import { render, staticRenderFns } from "./ChatControl.vue?vue&type=template&id=99c2e8fe&scoped=true&lang=pug&"
import script from "./ChatControl.vue?vue&type=script&lang=js&"
export * from "./ChatControl.vue?vue&type=script&lang=js&"
import style0 from "./ChatControl.vue?vue&type=style&index=0&id=99c2e8fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c2e8fe",
  null
  
)

component.options.__file = "ChatControl.vue"
export default component.exports